<template>
  <div class="editPage" v-loading="subLoading">
    <qx-card :title="pageTitle">
      <BaseForm
        ref="baseForm"
        @getOtherFormVal="getOtherFormVal"
        @getBaseFormInfo="getBaseFormInfo"
        @linkmanChange="linkmanChange"
      />
      <ImgInfo ref="imgInfo" @getOtherFormVal="getOtherFormVal" />
      <!-- <Belong ref="belong" @getOtherFormVal="getOtherFormVal" /> -->
      <Salary ref="salary" @getOtherFormVal="getOtherFormVal" />
      <Tenant ref="tenant" @getOtherFormVal="getOtherFormVal" />
      <Apply ref="apply" @getOtherFormVal="getOtherFormVal" />
      <BankCard ref="bankCard"></BankCard>
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import ImgInfo from './imgInfo';
// import Belong from './belong';
import Salary from './salary';
import Tenant from './tenant';
import Apply from './apply';
import BankCard from './bankCard';
import SubBtnBox from 'components/subBtnBox';
import {
  driverArchivesEdit,
  driverArchivesDetail,
} from 'api/archives';
import {
  getEnumList,
  getDepartmentAllList,
} from 'api';
import pageDataMixin from '@qx/mixin/pageData';
import {mapState} from 'vuex';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    ImgInfo,
    // Belong,
    Salary,
    Tenant,
    Apply,
    BankCard,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/archives/driver/archives/edit',
      formComponents: ['baseForm', 'imgInfo',
        // 'belong',
        'salary', 'apply', 'bankCard'],
      editParams: {
      },
      subLoading: false,
      // 需要对比的参数
      compareParams: {
        userId: '',
        mobilePhone: '',
        linkman: '',
        carUserType: '',
        attachedOrgId: '',
        driverOwnerShip: '',
        relId: '',
        tenantId: '',
        idenPictureFront: '',
        idenPictureBack: '',
        identification: '',
        adriverLicenseOriginal: '',
        adriverLicenseDuplicate: '',
        adriverLicenseSn: '',
        vehicleType: '',
        driverLicenseTime: '',
        qcCerti: '',
        qcCertiType: '',
        qcCertiTime: '',
        safetyAgreement: '',
        driverContract: '',
        driverLicenseExpiredTime: '',
        qcCertiExpiredTime: '',
        entryDate: '',
        salaryPattern: '',
        salary: '',
        subsidy: '',
        incomeRatio: '',
        basicSalary: '',
        minimumWage: '',
        userSalaryInfoList: '',
        entryState: '',

        acctName: '',

      },
    };
  },
  computed: {
    detailParams () {
      return {
        isEdit: 2,
        userId: this.$route.query.id,
      };
    },
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {
    detailApi: driverArchivesDetail,
    editApi: driverArchivesEdit,
    // 处理对比参数
    adjustCompareParams (compareParams) {
      if (compareParams.entryDate) {
        compareParams.entryDate = this.formatDate(compareParams.entryDate);
      }
    },
    async getOtherFormVal ({ from, tar }) {
      const tarFormData = await this.$refs[tar].cacheData();
      this.$refs[from] && this.$refs[from].receiveData(tar, tarFormData);
    },
    async getBaseFormInfo (baseForm) {
      this.$refs.imgInfo && this.$refs.imgInfo.getBaseFormInfo(baseForm);
    },
    async linkmanChange (linkman) {
      this.$refs.bankCard && this.$refs.bankCard.setBaseForm(linkman);
    },
  },
  async mounted () {
    const enumsList = await getEnumList({
      codeType: 'DRIVER_TYPE,OWNER_SHIP,SALARY_PATTERN_STS,QC_CERTI_TYPE,DRIVING_MODEL_TYPE,OWNER_SHIP',
    });
    const attachedOrgIdOptions = await getDepartmentAllList({
      pid: this.userInfo.staffTFInfo.orgIds,
      isArchive: true,
      // pid:'10991'
    });
    this.$refs.baseForm.setList(enumsList[0], enumsList[5], attachedOrgIdOptions);
    this.$refs.imgInfo.setList([enumsList[3], enumsList[4]]); // 从业资格证类型
    // await this.$refs.belong.getList();
    this.$refs.salary.setList(enumsList[2]); // 薪资模式
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
